import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

/**
 * PublicHeader — quiet masthead for anonymous visitors on Cherry's public
 * routes (newspaper, reader, views). Logged-in users see the LeafNav instead.
 *
 * Left: the Cherry leaf mark + wordmark. Right: two understated literary
 * pointers to Cherry's sibling publications (Cherry Times, Cherry Views) —
 * more a footnote than an ad banner — plus a sign-in link.
 */
export default function PublicHeader() {
  const { t } = useTranslation()
  return (
    <header className="w-full border-b border-parchment-dark/30 bg-parchment">
      <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-5 py-3">
        {/* Brand */}
        <Link to="/" className="flex items-center gap-2" aria-label="Cherry">
          <img
            src="/brand/cherry-leaf.svg"
            alt=""
            aria-hidden="true"
            className="h-6 w-6 opacity-80"
          />
          <span className="font-display text-lg text-ink">Cherry</span>
        </Link>

        {/* Quiet pointers + sign-in */}
        <nav className="flex items-center gap-4">
          <a
            href="https://cherry-times.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden font-body text-xs text-ink-muted transition-colors duration-200 hover:text-terra sm:inline"
          >
            Cherry Times ↗
          </a>
          <a
            href="https://cherry-views.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden font-body text-xs text-ink-muted transition-colors duration-200 hover:text-terra sm:inline"
          >
            Cherry Views ↗
          </a>
          {/* /login-gate works on every host (on cherry-times.com and
              cherry-views.com, "/" is the publication, not the sign-in). */}
          <Link
            to="/login-gate"
            className="font-body text-xs font-medium text-green transition-colors duration-200 hover:text-terra"
          >
            {t('home.welcome.signIn')}
          </Link>
        </nav>
      </div>
    </header>
  )
}
